import React, { useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
//components
//image
import logo from "../../assets/logo.png";
import darkLogo from "../../assets/darkLogo.png";

import { useAppContext } from "../../context/AppContext.jsx";
import PasswordInput from "../../components/input/PasswordInput.js";
import { resetPassword } from "../../services/Login/newPassword.js";

export default function NewPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // const { id } = useParams(); //get id
  // const { doc } = location.state; //get doc

  const [foto, setFoto] = useState(logo);
  const [loading, setLoading] = useState(false);

  const getDark = localStorage.getItem("appDarkMode");
  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();

  useEffect(() => {
    if (getDark === "true") {
      setFoto(logo);
    } else {
      if (window.innerWidth <= 992) {
        setFoto(logo);
      } else {
        setFoto(darkLogo);
      }
    }
  }, [getDark]);

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  const { control, handleSubmit, reset, formState } = useForm();

  const checkPasswordStrength = (password) => {
    const minLength = 8;
    const regexLowerCase = /[a-z]/;
    const regexUpperCase = /[A-Z]/;
    const regexDigit = /\d/;
    const regexSpecialChar = /[@$!%*?&#_+\-=/]/;
    if (password.length < minLength) {
      return "fraca";
    }
    let strength = 0;
    if (regexLowerCase.test(password)) strength++;
    if (regexUpperCase.test(password)) strength++;
    if (regexDigit.test(password)) strength++;
    if (regexSpecialChar.test(password)) strength++;
    if (strength < 3) {
      return "fraca";
    } else if (strength === 3) {
      return "média";
    } else {
      return "forte";
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);

//    console.log(data);

    const senha = checkPasswordStrength(data.password);
    if (senha === "fraca" || senha === "média") {
      toast.error(`Senha ${senha}`);
      setLoading(false);

      return;
    }
    if (data.confirmPassword !== data.password) {
      toast.error("As senhas devem ser iguais!");
      setLoading(false);

      return;
    }

    const validade = {
      email: searchParams.get("email"),
      token: searchParams.get("token"),
      environment_id: parseInt(searchParams.get("environment")),
      password: data.password,
      password_confirmation: data.confirmPassword,
      type: "sistema",
    };

//    console.log(validade);

    try {
      const response = await resetPassword(validade);
//      console.log(response);
      toast.success("Senha alterada com sucesso!");
      navigate("/");
    } catch (error) {
      toast.error("Falha ao redefinir senha!");
      reset({ email: "" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">
                <img src={foto} width={250} alt="Logo IB3 Capital" />
              </div>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              <form onSubmit={handleSubmit(onSubmit)}>
                <p>Informe sua nova a senha: </p>
                <div className="pb-3">
                  <PasswordInput
                    label="Senha *"
                    name="password"
                    errors={formState.errors}
                    control={control}
                    feedback={true}
                    rules={{ required: "Senha obrigatória." }}
                  />
                </div>

                <div className="pb-4">
                  <PasswordInput
                    errors={formState.errors}
                    control={control}
                    name="confirmPassword"
                    label="Confirme a Senha *"
                    feedback={false}
                    rules={{ required: "Senha obrigatória." }}
                  />
                </div>
                <div className="login-buttons">
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn h-45px btn-blue d-flex align-items-center justify-content-center w-100 btn-lg"
                  >
                    {loading ? (
                      <ThreeDots
                        height="80"
                        width="80"
                        radius="9"
                        color="#fff"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    ) : (
                      <>Enviar</>
                    )}
                  </button>

                  <div className="text-center pt-2">
                    <b>
                      <div
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => navigate("/")}
                        className="text-gray bg-transparent border-none"
                      >
                        Entrar <i className="fas fa-arrow-right ml-1"></i>
                      </div>
                    </b>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
